import { render, staticRenderFns } from "./TeacherContactOptions.vue?vue&type=template&id=aced4ff8&"
import script from "./TeacherContactOptions.vue?vue&type=script&lang=js&"
export * from "./TeacherContactOptions.vue?vue&type=script&lang=js&"
import style0 from "./TeacherContactOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports